import { AxiosError } from 'axios';
import { FC } from 'react';
import Button from '../../../../components/Button/Button';
import { Variant } from '../../../../components/Button/Button.types';
import Table from '../../../../components/Table/Table';
import { showToast } from '../../../../components/Toast/Toast';
import { genericErrorShowToastOptions } from '../../../../utils/useGenericErrorMessage/useGenericErrorMessage';
import { Buttons } from '../UpdateRecipeDetails/UpdateRecipeDetails.styles';
import { DescriptionUpdateRule, FprodUpdateRule } from '../UpdateRecipeDetails/UpdateRecipeDetails.types';
import { DescriptionSection, Label, ReviewChangesPage, StyledH2, TableSection, Value } from './ReviewChanges.styles';
import { ReviewChangesProps } from './ReviewChanges.types';

const ReviewChanges: FC<ReviewChangesProps> = ({ selectedRecipes, setStep, formValues, mutate, isLoading }) => {
  const handleNextClick = () => {
    mutate(
      {
        specNos: selectedRecipes.map((recipe) => recipe.recipeId),
        ruleDescriptionUpdateEnum: formValues.descriptionUpdateRule,
        ruleFmsProdUpdateEnum: formValues.fprodUpdateRule,
        description: formValues.description,
        longDescription: formValues.longDescription,
        fmsProdNo: +formValues.fmsProdNo,
      },
      {
        onSuccess: () => {
          setStep(3);
          showToast({
            id: 'copyRecipeSuccess',
            label: 'Recipes were copied successfully.',
          });
        },
        onError: (error) => {
          if ((error as AxiosError).message === 'apiGatewayTimeout') return;
          showToast({
            ...genericErrorShowToastOptions,
            id: 'copyRecipeError',
            label: 'Error copying recipes.',
          });
        },
      }
    );
  };

  const descriptionRuleLabels = {
    0: 'Do not update descriptions',
    1: 'Replace descriptions with new descriptions',
    2: 'Append to existing long description',
  };

  const fprodRuleLabels = {
    0: 'Do not copy/apply FPROD',
    1: 'Apply new FPROD',
    2: 'Copy existing FPROD',
  };

  return (
    <ReviewChangesPage>
      <TableSection>
        <StyledH2>Review your changes</StyledH2>
        <Table
          headerTitle='Copy Recipe Target'
          showHeader={true}
          height={'40vh'}
          headerButtons={[{ label: 'Edit', variant: Variant.Text, onClick: () => setStep(0) }]}
          rowData={selectedRecipes}
          columnDefs={[
            { field: 'specNo', headerName: 'Recipe', resizable: false, width: 80, floatingFilter: false },
            { field: 'description', headerName: 'Description', resizable: false, flex: 1, floatingFilter: false },
          ]}
          returnedRecords={selectedRecipes.length}
        />
      </TableSection>
      <StyledH2>Description Update Summary</StyledH2>
      <DescriptionSection>
        <Label row={1}>Description Update:</Label>
        <Label row={2}>Description:</Label>
        <Label row={3}>Long Description:</Label>
        <Label row={4}>FPROD Update:</Label>
        <Label row={5}>FPROD:</Label>
        <Value row={1}>{descriptionRuleLabels[formValues.descriptionUpdateRule]}</Value>
        <Value row={2}>
          {formValues.descriptionUpdateRule === DescriptionUpdateRule.REPLACE_DESCRIPTION ? formValues.description : ''}
        </Value>
        <Value row={3}>
          {formValues.descriptionUpdateRule === DescriptionUpdateRule.NO_ACTION ? '' : formValues.longDescription}
        </Value>
        <Value row={4}>{fprodRuleLabels[formValues.fprodUpdateRule]}</Value>
        <Value row={5}>{formValues.fprodUpdateRule === FprodUpdateRule.APPLY_NEW ? formValues.fmsProdNo : ''}</Value>
      </DescriptionSection>
      <Buttons>
        <Button label='Back' variant={Variant.Secondary} onClick={() => setStep(1)} />
        <Button label='Save' onClick={handleNextClick} isLoading={isLoading} />
      </Buttons>
    </ReviewChangesPage>
  );
};

export default ReviewChanges;
